import { useEffect, useRef, useState } from 'react'
import { ReactComponent as Dot } from '../assets/icons/dot.svg'
import { ReactComponent as Search } from '../assets/icons/search.svg'
import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as Favorites } from '../assets/icons/favorites.svg'
import { ReactComponent as FavoritesOutlined } from '../assets/icons/favorites-outlined.svg'
import { ReactComponent as Download } from '../assets/icons/download.svg'
import { ReactComponent as Delete } from '../assets/icons/delete.svg'
import { ReactComponent as Edit } from '../assets/icons/edit.svg'
import { ReactComponent as Close } from '../assets/icons/close.svg'
import { ReactComponent as UploadFile } from '../assets/icons/upload-file.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as Warning } from '../assets/icons/warning.svg'
import { fileTypeList } from '../assets/data.js'

import FileProgressModal from './FileProgressModal'
import {
  deleteDocuments,
  getDocuments,
  patchDocumentsFavorite,
  postDocumentsDownload,
  postDocumentsUploads,
} from '../apis/document.ts'
import { DeleteModal, OverWriteModal, RenameModal } from './Modal.jsx'
import axios from 'axios'

export default function ClassDataTab({ subjectId }) {
  const [isActive, setIsActive] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isOverWriteModalOpen, setIsOverWriteModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false)
  const [sortedBy, setSortedBy] = useState(1)
  const [selectedDocument, setSelectedDocument] = useState([])
  const [documentList, setDocumentList] = useState()
  const [fileInfo, setFileInfo] = useState([])
  const [errorFileInfo, setErrorFileInfo] = useState([])
  const [currentModalIndex, setCurrentModalIndex] = useState(0)

  useEffect(() => {
    window.addEventListener('dragover', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })

    window.addEventListener('drop', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })
  }, [])

  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 5000)

    return () => clearTimeout(timer)
  }, [isVisible])

  const sortedByList = [
    { id: 1, name: '파일 이름순', type: 'name' },
    { id: 2, name: '최근 수업 이용 순', type: 'recentUse' },
    { id: 3, name: '최근 등록 순', type: 'recentPost' },
  ]

  /*************** 외부 영역 클릭 Ref **************/
  const documentRef = useRef()
  const modalRef = useRef()
  // console.log(modalRef)
  useEffect(() => {
    function handleClickOutside(e) {
      e.stopPropagation()
      if (
        documentRef.current &&
        !documentRef.current.contains(e.target) &&
        e.target.id !== 'button-activate'
      ) {
        setSelectedDocument([])
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isDeleteModalOpen, isRenameModalOpen, isOverWriteModalOpen])

  /*************** 자료목록 조회 API **************/
  const [search, setSearch] = useState('')

  useEffect(() => {
    getDocumentsApi()
    // eslint-disable-next-line
  }, [sortedBy, search])

  const getCategoryType = (id) => {
    const item = sortedByList.find((item) => item.id === id)
    return item.type
  }

  const getDocumentsApi = async () => {
    const getDocumentsResponse = await getDocuments({
      subjectId: subjectId,
      name: search,
      sortBy: getCategoryType(sortedBy),
    })

    if (getDocumentsResponse.error) {
      console.log(getDocumentsResponse.error)
      return
    } else {
      // console.log(getDocumentsResponse.data)
      setDocumentList(getDocumentsResponse.data)
    }
  }

  /*************** 파일 업로드 API **************/
  const handleDrop = async (e) => {
    e.preventDefault()
    setIsActive(false)
    const fileList = e.dataTransfer.files
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i]
      postDocumentsUploadsApi(file, null, i)
    }
  }

  const handleFileUpload = (e) => {
    const fileList = e.target.files
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i]
      postDocumentsUploadsApi(file, null, i)
    }
  }

  const postDocumentsUploadsApi = async (file, action, i) => {
    setIsModalOpen(true)
    const fileInfoItem = {
      index: i,
      name: file.name,
      size: file.size,
      type: file.type,
      progress: 0,
      status: null,
    }
    setFileInfo((prev) => [...prev, fileInfoItem])

    const postDocumentsUploadsResponse = await postDocumentsUploads(
      { subjectId: subjectId, action: action },
      { files: file },
      (currentProgress) => {
        setFileInfo((prev) =>
          prev.map((item) =>
            item.index === fileInfoItem.index ? { ...item, progress: currentProgress } : item,
          ),
        )
      },
    )

    if (postDocumentsUploadsResponse.error) {
      if (postDocumentsUploadsResponse.error.code === 'E409') {
        setIsOverWriteModalOpen(true)
        setErrorFileInfo((prev) => [...prev, file])
        setFileInfo((prev) =>
          prev.map((item) =>
            item.index === fileInfoItem.index ? { ...item, status: 'error' } : item,
          ),
        )
      } else {
        setErrorMessage(postDocumentsUploadsResponse.error.message)
        setIsVisible(true)
        setFileInfo((prev) =>
          prev.map((item) =>
            item.index === fileInfoItem.index ? { ...item, status: 'error' } : item,
          ),
        )
      }
      return
    } else {
      console.log(postDocumentsUploadsResponse.result)
      setFileInfo((prev) =>
        prev.map((item) =>
          item.index === fileInfoItem.index ? { ...item, status: 'success' } : item,
        ),
      )
      await getDocumentsApi()
      setErrorMessage()
    }
  }

  /*************** 파일 다운로드 API **************/
  const postDocumentsDownloadApi = async (file) => {
    const postDocumentsDownloadResponse = await postDocumentsDownload(file)
    if (postDocumentsDownloadResponse.error) {
      console.log(postDocumentsDownloadResponse.error)
      return
    } else {
      postDocumentsDownloadResponse.data.forEach((file) =>
        handleFileDownload(file.fileName, file.fileSignUrl),
      )
    }
  }
  const downloadFile = (blob, name) => {
    const anchorElement = document.createElement('a')
    const localUrl = window.URL.createObjectURL(blob)
    anchorElement.href = localUrl
    anchorElement.download = name
    anchorElement.style.display = 'none'
    document.body.appendChild(anchorElement)
    anchorElement.click()
    document.body.removeChild(anchorElement)
    window.URL.revokeObjectURL(localUrl) // cleanup - 쓰임을 다한 url 객체 삭제
    setSelectedDocument(selectedDocument)
  }

  const handleFileDownload = (fileName, fileUrl) => {
    axios
      .get(fileUrl, { responseType: 'blob' })
      .then((response) => {
        return new Blob([response.data], { type: response.headers['Content-Type'] })
      })
      .then((result) => {
        downloadFile(result, fileName)
      })

    // const link = document.createElement('a')
    // link.target = '_blank'
    // link.href = fileUrl
    // link.download = fileName
    // link.style.display = 'none'
    // document.body.appendChild(link)
    // link.click()
    // document.body.removeChild(link)
  }

  /*************** 파일 삭제 API **************/
  const deleteDocumentsApi = async (selectedDocument) => {
    const deleteDocumentsResponse = await deleteDocuments(selectedDocument)

    if (deleteDocumentsResponse.error) {
      console.log(deleteDocumentsResponse.error)
      return
    } else {
      console.log(deleteDocumentsResponse.result)
      await getDocumentsApi()
      setSelectedDocument([])
    }
  }

  const handleSelectClick = (documentItem) => {
    if (!selectedDocument.includes(documentItem.id)) {
      setSelectedDocument((prev) => [...prev, documentItem.id])
    } else {
      const unSelectedDocument = selectedDocument.filter((item) => item !== documentItem.id)
      setSelectedDocument(unSelectedDocument)
    }
  }

  /*************** 즐겨찾기 API **************/
  const patchDocumentsFavoriteApi = async (selectedDocument, isFavorite) => {
    const patchDocumentsFavoriteResponse = await patchDocumentsFavorite({
      documentIds: selectedDocument,
      isFavorite: isFavorite,
    })

    if (patchDocumentsFavoriteResponse.error) {
      console.log(patchDocumentsFavoriteResponse.error)
      return
    } else {
      console.log(patchDocumentsFavoriteResponse.result)
      await getDocumentsApi()
      // setSelectedDocument([])
    }
  }

  const findItem = (list, id) => {
    const item = list?.find((item) => item?.id === id)
    return item
  }

  console.log(selectedDocument)

  return (
    <div
      onDragEnter={(e) => {
        e.preventDefault()
        setIsActive(true)
      }}
      onDragOver={(e) => {
        e.preventDefault()
        setIsActive(true)
      }}
      onDragLeave={() => {
        setIsActive(false)
      }}
      onDrop={handleDrop}
      className='flex h-full w-full justify-center overflow-hidden'
    >
      <div
        className={`h-full w-full rounded-16 px-24 py-20 ${isActive ? 'border border-border-active bg-background-secondary opacity-30' : 'border_default bg-background-default'}`}
      >
        <div ref={documentRef} className='flex h-full w-full flex-col items-center gap-16'>
          {/* menu */}
          {selectedDocument.length > 0 ? (
            <div className='border_default flex min-h-[38px] w-full items-center gap-24 rounded-16 bg-background-default px-16 py-4'>
              <div
                onClick={() => setSelectedDocument([])}
                className='flex items-center gap-4 fill-label-sub py-4'
              >
                <Close />
                <p className='text-body2-medium text-label-sub'>{selectedDocument.length}개 선택</p>
              </div>
              <div className='h-20 w-[1px] bg-border-default' />
              <div
                onClick={() => postDocumentsDownloadApi(selectedDocument)}
                className='flex items-center gap-4 fill-label-sub py-4'
              >
                <Download />
                <p className='text-body2-medium text-label-sub'>다운로드</p>
              </div>
              <div
                onClick={() => setIsDeleteModalOpen(true)}
                className='flex items-center gap-4 fill-status-negative py-4'
              >
                <Delete />
                <p className='text-body2-medium text-status-negative'>선택삭제</p>
              </div>
              <div
                onClick={() => setIsRenameModalOpen(true)}
                className={`${selectedDocument.length === 1 ? 'fill-label-sub text-label-sub' : 'fill-label-disable text-label-disable'} flex items-center gap-4 py-4`}
              >
                <Edit />
                <p className='text-body2-medium'>이름 변경</p>
              </div>
              {selectedDocument?.every((id) => findItem(documentList, id)?.isFavorite === true) ? (
                <div
                  onClick={() => patchDocumentsFavoriteApi(selectedDocument, false)}
                  className='flex items-center gap-4 fill-label-sub py-4'
                >
                  <FavoritesOutlined className='h-16 w-16' />
                  <p className='text-body2-medium text-label-sub'>즐겨찾기 해제</p>
                </div>
              ) : (
                <div
                  onClick={() => patchDocumentsFavoriteApi(selectedDocument, true)}
                  className='flex items-center gap-4 fill-label-sub py-4'
                >
                  <Favorites className='h-16 w-16' />
                  <p className='text-body2-medium text-label-sub'>즐겨찾기</p>
                </div>
              )}
            </div>
          ) : (
            <div className='flex min-h-[38px] w-full justify-between'>
              <div className='flex items-center gap-16'>
                {sortedByList.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => setSortedBy(item.id)}
                    className={`flex cursor-pointer items-center justify-center gap-4 ${
                      sortedBy === item.id
                        ? 'fill-label-sub text-label-sub'
                        : 'fill-label-placeholder text-label-placeholder'
                    }`}
                  >
                    <Dot />
                    <p className='text-body3-medium'>{item.name}</p>
                  </div>
                ))}
              </div>
              <div className='flex items-center gap-8'>
                <div className='relative'>
                  <Search className='absolute left-16 top-8' />
                  <input
                    type='text'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder='자료 검색'
                    className='input_sm pl-40'
                  />
                  {search && (
                    <CloseFilled
                      onClick={() => setSearch('')}
                      className='absolute right-8 top-8 cursor-pointer'
                    />
                  )}
                </div>
                <label className='button_outlined_assistive_sm gap-4'>
                  <input
                    className='hidden'
                    type='file'
                    multiple
                    onChange={handleFileUpload}
                    accept='.jpg, .png, .pdf, .ppt'
                  />
                  <Add className='h-16 w-16' />
                  <p>자료 등록</p>
                </label>
              </div>
            </div>
          )}
          {/* dataList */}
          <div className='h-full w-full'>
            <div className='flex w-full items-center justify-between gap-8 border-y-[1px] border-solid border-border-default bg-fill-alternative py-8 pl-16 pr-20 text-body3-regular text-label-info'>
              <p className='min-w-[740px]'>이름</p>
              <p className='min-w-[140px]'>등록 일자</p>
            </div>
            <div className='tab-scroll-bar h-[calc(100%-74px)] w-full overflow-y-auto pr-4'>
              {search && documentList.length === 0 ? (
                <div className='flex h-full w-full items-center justify-center'>
                  <p className='text-center text-body1-long-medium text-label-placeholder'>
                    검색 결과가 없습니다.
                    <br />
                    검색하고자 하는 글자를 완전히 입력하거나 다른 검색어를 입력해보세요.
                  </p>
                </div>
              ) : (
                documentList?.map((documentItem, documentIndex) => (
                  <div
                    // ref={menuRef}
                    key={documentIndex}
                    onClick={() => {
                      handleSelectClick(documentItem)
                    }}
                    className='relative'
                  >
                    <div
                      className={`${selectedDocument.includes(documentItem.id) ? 'bg-background-secondary' : 'bg-background-default'} flex items-center justify-between border-b-[1px] border-solid border-border-default p-16 active:bg-background-secondary`}
                    >
                      <div className='flex w-full items-center justify-between'>
                        <div className='flex min-w-[740px] gap-16 fill-label-info'>
                          <div className='flex gap-8'>
                            <div className='h-24 w-24'>{fileTypeList[documentItem.fileType]}</div>
                            <p className='text-center text-body1-regular text-label-sub'>
                              {`${documentItem.fileName}.${documentItem.fileType.toLowerCase()}`}
                            </p>
                          </div>
                          {documentItem.isFavorite ? <Favorites /> : null}
                        </div>
                        <p className='min-w-[140px] text-body2-medium text-label-sub'>
                          {documentItem.createdAt}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <FileProgressModal
          close={() => setIsModalOpen(false)}
          fileInfo={fileInfo}
          setFileInfo={setFileInfo}
        />
      )}
      {isActive && (
        <div className='absolute bottom-16 z-20 flex items-center justify-center gap-8 rounded-90 bg-border-active py-4 pl-4 pr-16 shadow-emphasize'>
          <UploadFile />
          <p className='text-body1-long-medium text-static-white'>
            이곳에 파일을 놓으면 업로드를 시작합니다
          </p>
        </div>
      )}
      {isVisible && errorMessage && (
        <div className='absolute bottom-16 flex items-center gap-8 rounded-90 border border-status-negative bg-red-99 fill-status-negative px-16 py-12 shadow-emphasize'>
          <Warning />
          <p className='text-body1-long-regular text-status-negative'>{errorMessage}</p>
        </div>
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          close={() => setIsDeleteModalOpen(false)}
          content={'document'}
          onStateChange={() => setIsDeleteModalOpen(false)}
          deleteApi={() => deleteDocumentsApi(selectedDocument)}
        />
      )}
      {isRenameModalOpen && (
        <div ref={modalRef}>
          <RenameModal
            existingName={findItem(documentList, selectedDocument[0])?.fileName}
            selectedDocument={selectedDocument}
            close={() => {
              setIsRenameModalOpen(false)
            }}
            getApi={() => getDocumentsApi()}
          />
        </div>
      )}
      {isOverWriteModalOpen && currentModalIndex < errorFileInfo.length && (
        <OverWriteModal
          key={currentModalIndex}
          close={() => {
            if (currentModalIndex + 1 < errorFileInfo.length) {
              setCurrentModalIndex(currentModalIndex + 1)
            } else {
              setIsOverWriteModalOpen(false)
            }
          }}
          fileInfo={errorFileInfo[currentModalIndex]}
          postApi={(file, action) => postDocumentsUploadsApi(file, action)}
          subjectId={subjectId}
          setFileInfo={setFileInfo}
        />
      )}
    </div>
  )
}
